import { FetchFailureAction, FetchRequestAction, FetchSuccessAction, StrapiActionTypes, StrapiItem } from '../../types/strapiVPO';

export const fetchData = (modelName: string, filters?: any, pagination?: { page: number; pageSize: number }): FetchRequestAction => {
  let params: Record<string, any> = {};

  if (pagination) {
    params['pagination[page]'] = pagination.page;
    params['pagination[pageSize]'] = pagination.pageSize;
  }

  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (key.startsWith('filters[')) {
        params[key] = value;
      } else {
        params[`filters[${key}]`] = value;
      }
    });
  }

  return {
    type: StrapiActionTypes.FETCH_REQUEST_VPO,
    payload: {
      modelName,
      params,
      pagination,
    },
  };
};

export const fetchDataSuccessVPO = (
  modelName: string,
  data: StrapiItem[],
  pagination?: {
    page: number;
    pageSize: number;
    pageCount: number;
    total: number;
  }
): FetchSuccessAction => ({
  type: StrapiActionTypes.FETCH_SUCCESS_VPO,
  payload: {
    modelName,
    data,
    pagination,
  },
});

export const fetchDataFailureVPO = (modelName: string, error: string): FetchFailureAction => ({
  type: StrapiActionTypes.FETCH_FAILURE_VPO,
  payload: {
    modelName,
    error,
  },
});
